// Use the rendered panels so adding a fourth card automatically enables paging.
export default {
  data: () => ({ rankPanelCount: 0 }),
  mounted() { this.syncRankPanels() },
  updated() { this.syncRankPanels() },
  beforeDestroy() { if (this.rankObserver) this.rankObserver.disconnect() },
  methods: {
    syncRankPanels() {
      const grid = this.$refs.rankGrid
      if (grid === this.rankGridObserved) { this.rankPanelCount = grid ? grid.children.length : 0; return }
      if (this.rankObserver) this.rankObserver.disconnect()
      this.rankGridObserved = grid
      this.rankPanelCount = grid ? grid.children.length : 0
      if (!grid) return
      this.rankObserver = new MutationObserver(() => { this.rankPanelCount = grid.children.length })
      this.rankObserver.observe(grid, { childList: true })
    },
    scrollRanks(direction) {
      const grid = this.$refs.rankGrid
      if (grid) grid.scrollBy({ left: direction * grid.clientWidth, behavior: 'smooth' })
    }
  }
}
